import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";
import { rmaStatusParams } from "@NA/Handlers/ADIRMAStatusHandler";
import ADIRMAStatusModel from "../Data/ADIRMAStatusState";
import { GetRMAStatusParamater } from "@NA/Services/ADIRMAStatusService";

const initialState: ADIRMAStatusModel = {
    isLoading: false,
    loadRMAStatusParameters: rmaStatusParams,
    rmaStatusResults: null,
};

const reducer = {
    "Custom/LoadRMAStatus": (draft: Draft<ADIRMAStatusModel>, action: { result: GetRMAStatusParamater }) => {
        draft.isLoading = true;
        draft.loadRMAStatusParameters = action.result;
    },
    "Custom/LoadRMAStatusOrder": (draft: Draft<ADIRMAStatusModel>, action: { result: any }) => {
        draft.rmaStatusResults = action.result.result;
    },
    "Custom/LoadRMAStatusComplete": (draft: Draft<ADIRMAStatusModel>) => {
        draft.isLoading = false;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
